module.exports = __webpack_public_path__ + "static/media/lipstickDefault.cdd734dc.png";